module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl2-50.0e371191.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/images/direction-D-lvl2-50.png
// module id = 3399
// module chunks = 11